import '.b0{flex:1;}.ssr-plugin'
import '.a6{min-width:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.bw{justify-content:flex-end;}.ssr-plugin'
import '.g2{min-width:10rem;}.ssr-plugin'
import '.aq{overflow:hidden;}.ssr-plugin'
import { Text } from '@app/components/core/typography/Text'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { useLocation } from 'wouter'
import Column from '@app/components/layout/Column'
import { INITIATIVE_USER_ROLES } from '@schema/initiative'
import { pages } from '@app/util/links'
import Row from '@app/components/layout/Row'
import { CardWrapper } from '@app/components/blocks/card/CardWrapper'
import { Tag } from '@app/components/core/tag/Tag'
import useMediaQuery from '@app/util/useMediaQuery'
import { DahsboardListInitiativeModel } from 'functions/app/dashboard/profile/initiative/list'
import { styled, type Style } from 'inlines'

export const AdministeredInitiative = ({
  initiative,
}: {
  initiative: DahsboardListInitiativeModel
}) => {
  const isMobile = useMediaQuery()
  const [_location, navigate] = useLocation()
  const t = useTranslations()
  const translations = t.app.dashboard.initiative.home
  const commonTranslations = t.app.common

  const members = initiative.users.reduce(
    (prev, current) =>
      current.$role === INITIATIVE_USER_ROLES.member ? prev + 1 : prev,
    0,
  )

  const followers = initiative.users.reduce(
    (prev, current) =>
      current.$role === INITIATIVE_USER_ROLES.follower ? prev + 1 : prev,
    0,
  )

  const tagText = !initiative.isLive
    ? translations.initiativeDraft
    : initiative.searchingForMembers
      ? commonTranslations.initiativeStatus.searchingForMembers
      : commonTranslations.initiativeStatus.notSearchingForMembers

  const tagColor =
    initiative.isLive && initiative.searchingForMembers ? 'accent' : 'neutral'

  const title = initiative.title?.trim() || translations.unnamedInitiative

  return (
    <CardWrapper
      padding={isMobile ? '1rem' : '1rem 2.75rem'}
      onClick={() =>
        navigate(pages.dashboardViewInitiative(initiative.id.toString()))
      }
      style={{
        border: 'var(--border-subtle)',
      }}
    >
      {isMobile ? (
        <Column>
          <AdministeredInitiativeHeader
            title={title}
            description={initiative.description}
          />

          <AdministeredInitiativeBody members={members} followers={followers} />

          <Tag label={tagText} variant={tagColor} size="small" />
        </Column>
      ) : (
        <Row
          style={{ alignItems: 'center', justifyContent: 'space-between' }}
          gap="1.5rem"
        >
          <div className="b0 a6">
            <AdministeredInitiativeHeader
              title={title}
              description={initiative.description}
            />
          </div>
          <AdministeredInitiativeBody members={members} followers={followers} />
          <div className="d bw g2"
          >
            <Tag label={tagText} variant={tagColor} size="small" />
          </div>
        </Row>
      )}
    </CardWrapper>
  )
}

const AdministeredInitiativeHeader = ({
  title,
  description,
  style,
}: {
  title: string
  description: string
  style?: Style
}) => {
  const isMobile = useMediaQuery()

  return (
    <styled.div className="aq" style={{ ...style }}>
      <Title.H5>{title}</Title.H5>
      <Text.Small
        style={
          isMobile
            ? {}
            : {
                display: 'block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }
        }
      >
        {description}
      </Text.Small>
    </styled.div>
  )
}

const AdministeredInitiativeBody = ({
  members,
  followers,
}: {
  members: number
  followers: number
}) => {
  const t = useTranslations().app.dashboard.initiative.home

  return (
    <>
      <Column gap={0} style={{ flex: 'none' }}>
        <Text.Small>{t.membersLabel}</Text.Small>
        <Text.Medium isBold={true}>{members}</Text.Medium>
      </Column>
      <Column gap={0} style={{ flex: 'none' }}>
        <Text.Small>{t.followersLabel}</Text.Small>
        <Text.Medium isBold={true}>{followers}</Text.Medium>
      </Column>
    </>
  )
}
